import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useGetLines } from '@/hooks/useGetLines';
import { SelectOptions } from '@/components/ui/SelectOptions';
import * as S from './styles';

const { useWatch } = Form;

interface LineFormItemProps {
	disabled?: boolean;
}

export function LineFormItem({ disabled = false }: LineFormItemProps) {
	const form = Form.useFormInstance();
	const organization_id: string = useWatch('organization_id');
	const company_id: string = useWatch('company_id');
	const sector_id: string = useWatch('sector_id');

	const { isLoading, data: lines = [] } = useGetLines({
		organization_id,
		company_id,
		sector_id
	});

	function handleOnChange(): void {
		form.setFieldValue('workstation_id', undefined);
	}

	const isDisabled = disabled || !organization_id || !company_id || !sector_id;

	return (
		<S.CustomFormItem name="line_id" label={I18n.get('Line')} labelCol={{ span: 24 }}>
			<SelectOptions
				allowClear
				disabled={isDisabled}
				options={lines}
				onChange={disabled ? undefined : handleOnChange}
				placeholder={I18n.get('Line')}
				loading={isLoading}
			/>
		</S.CustomFormItem>
	);
}
